import {
  Screen,
  StaticLandingType,
  SubtabMenu,
} from '../../../graphql/generated/types';

export function findSubtabMenuAndScreen({
  subtabMenuList,
  subtab,
  landing,
}: {
  subtabMenuList: SubtabMenu[];
  subtab?: {
    menuUid?: number;
    screenUid?: number;
  };
  landing?: {
    landingType?: StaticLandingType;
    categoryUid?: number;
  };
}):
  | {
      subtabMenu: SubtabMenu;
      screen: Screen;
    }
  | undefined {
  if (!subtabMenuList) {
    return;
  }

  if (subtab) {
    for (const subtabMenu of subtabMenuList) {
      if (subtabMenu.uid !== subtab.menuUid) {
        continue;
      }
      if (!subtab.screenUid) {
        return {
          subtabMenu,
          screen: subtabMenu.screenList[0],
        };
      }
      for (const screen of subtabMenu.screenList) {
        if (screen.uid === subtab.screenUid) {
          return {
            screen,
            subtabMenu,
          };
        }
      }

      return {
        subtabMenu,
        screen: subtabMenu.screenList[0],
      };
    }
  } else if (landing) {
    for (const subtabMenu of subtabMenuList) {
      for (const screen of subtabMenu.screenList) {
        if (
          screen.landingType === landing.landingType &&
          screen.categoryUid === landing.categoryUid
        ) {
          return {
            screen,
            subtabMenu,
          };
        }
      }
    }
  }
}
